'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;

var parseAngle = exports.parseAngle = function parseAngle(angle) {
  var match = angle.match(ANGLE);

  if (match) {
    var value = parseFloat(match[1]);

    switch (match[2].toLowerCase()) {
      case 'deg':
        return Math.PI * value / 180;

      case 'grad':
        return Math.PI / 200 * value;

      case 'rad':
        return value;

      case 'turn':
        return Math.PI * 2 * value;
    }
  }

  return null;
};